import "../rentaroomstyle.css";

export default function RentARoomTalepler() {
  return (
    <div className="rar-page">
      <div style={{ marginBottom: 20 }}>
        <h4 className="rar-page-title">
          <i className="bi bi-inbox-fill me-2" style={{ color: "#3b82f6" }}></i>Talepler
        </h4>
        <p className="rar-page-subtitle">Tüm talepleri buradan takip edebilirsiniz.</p>
      </div>

      <div className="rar-empty-card">
        <i className="bi bi-inbox" style={{ fontSize: "2.5rem", display: "block", marginBottom: 12 }}></i>
        <p style={{ margin: 0, fontSize: "0.9rem" }}>Henüz talep bulunmuyor.</p>
      </div>
    </div>
  );
}
